import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SubmitClaimService {

  constructor(private httpClient: HttpClient) { }

  submitClaim(claimId: number) {
    return this.httpClient.put(`${environment.apiServer}/SubmitClaim?claimId=${claimId}`, null);
  }
}
